/* eslint-disable jsx-a11y/alt-text */
import { Divider, Paper, Stack } from '@mui/material';
import { IProduct } from 'types/productType';
import React from 'react';
import { AddProductButton } from '../../pages/homePage/components/AddProductButton/AddProductButton';

export type IProductProps = {
    product: IProduct;
    callback?: () => void;
}

const Product: React.FC<IProductProps> = ({ product, callback }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        flexGrow: 1,
        height: '250px',
        m: '10px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={product.image}
          style={{
            height: '150px',
            alignSelf: 'center',
            overflow: 'hidden',
            objectFit: 'cover',
          }}
        />
      </div>
      <Divider />
      <div style={{
        marginLeft: '4px',
        maxLines: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginRight: '15px',
      }}
      >
        <p>{product.productName}</p>
        <Stack
          direction="row"
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <p style={{
            alignSelf: 'center',
          }}
          >
            Price:
            {' '}
            {product.sellingPrice}

          </p>
          <div style={{
            flexGrow: 1,
          }}
          />
          <AddProductButton product={product} callback={callback} />
        </Stack>
      </div>
    </Paper>
  );
};

export { Product };
